import React from "react";
import { chefInfo, heroImage } from "../mock";
import { ArrowDown } from "lucide-react";

export default function Hero() {
  return (
    <section id="home" className="relative bg-neutral-950 text-[#fbf3e4] overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 min-h-[100vh] items-center px-6 lg:px-10 pt-28 pb-16 gap-10">
        <div className="fade-up">
          <p className="text-xs tracking-[0.4em] text-neutral-400 mb-6">ESTD 2024 &middot; THE PRIVATE CHEF METE</p>
          <h1 className="font-display text-6xl md:text-7xl lg:text-8xl leading-[0.95]">
            {chefInfo.name}
          </h1>
          <h2 className="font-serif-display text-4xl md:text-5xl mt-4 text-neutral-100/95">
            {chefInfo.title}
          </h2>
          <p className="mt-8 max-w-md text-neutral-300 text-base leading-relaxed">
            {chefInfo.tagline}
          </p>
          <div className="mt-10 flex items-center gap-5">
            <a
              href="#contact"
              className="btn-primary bg-[#fbf3e4] text-neutral-900 px-6 py-3 text-sm font-medium tracking-wide hover:bg-white"
            >
              Book Now
            </a>
            <a href="#about" className="nav-link text-sm text-neutral-200 flex items-center gap-2">
              Discover more <ArrowDown size={16} />
            </a>
          </div>
        </div>

        <div className="relative flex justify-center lg:justify-end fade-up">
          <div className="relative w-full max-w-xl aspect-[4/5] overflow-hidden hero-image-shadow">
            <img
              src={heroImage}
              alt="Signature dish"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-5 right-5 w-16 h-16 rounded-full bg-[#fbf3e4] flex flex-col items-center justify-center text-neutral-900">
              <span className="font-display text-xl leading-none">M</span>
              <span className="text-[8px] tracking-[0.2em] mt-0.5">CHEF</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
